import { createCrudPage } from './factories/crud-page.js';

const basePath = '/expo-main';

export default createCrudPage({
  title: 'Expos (Main)',
  basePath,
  columns: [
    { key: 'type_name', label: 'Type', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'continent_name', label: 'Continent', sortable: true },
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'city', label: 'City', sortable: true },
    { key: 'start', label: 'Start', sortable: true },
    { key: 'finish', label: 'Finish', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'type', label: 'Type', type: 'async-select',
      optionsUrl: '/expo-types/options',
      placeholder: 'Select type' },
    { key: 'attendance_mode', label: 'Attendance mode', type: 'async-select',
      optionsUrl: '/expo-attendance-modes/options',
      placeholder: 'Select mode' },
    { key: 'continent', label: 'Continent', type: 'async-select',
      optionsUrl: '/expo-continents/options',
      placeholder: 'Select continent' },
    { key: 'country', label: 'Country', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'start', label: 'Start', type: 'datetime' },
    { key: 'finish', label: 'Finish', type: 'datetime' },
    { key: 'website', label: 'Website', type: 'text' },
    { key: 'description', label: 'Description', type: 'rich-text' },
    { key: 'booth', label: 'Booth', type: 'text' },
    { key: 'logo', label: 'Logo', type: 'file', accept: 'image/*', photo: true },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'duplicate', label: 'Duplicate', icon: 'duplicate',
      confirm: 'Are you sure you want to duplicate this expo?' },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  customActions: (ctx) => ({
    duplicate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      const data = await ctx.adapter.get(id);
      const { id: _id, created: _created, ...rest } = data;
      ctx.editor.open(undefined, { prefill: rest });
    },
  }),
  defaultSort: { field: 'start', dir: 'desc' },
});
